module.exports = __webpack_public_path__ + "static/media/no-image.fbcefd08.png";